import React, { useEffect, useState } from "react";
import { API } from "../../../../Common/lib/api";
import { Storage } from "../../../../Common/lib/storage";
import { Document, Page, pdfjs } from "react-pdf";
import { useHistory } from "react-router-dom";
import { MapContainer, TileLayer } from "react-leaflet";
import GPXDisplay from "../../GPXVisualization/GPXDisplay.js";

export default function EditPage(props) {
  const [visualizationTitle, setVisualizationTitle] = useState("");
  const [visualizationDesc, setVisualizationDesc] = useState("");
  const [visualization, setVisualization] = useState({});
  const [visualizationsLoading, setVisualizationsLoading] = useState([]);
  const [projectId, setProjectId] = useState();
  const [index, setIndex] = useState();
  const [numPages, setNumPages] = useState(null);
  const history = useHistory();

  const handleTitleChange = (event) => {
    setVisualizationTitle(event.target.value);
  };

  const handleDescChange = (event) => {
    setVisualizationDesc(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const projectIdParam = urlParams.get("projectId") || urlParams.get("pk");
        const index = urlParams.get("index");

        setProjectId(projectIdParam);
        setIndex(index);

        const projectQuery = await API.projects.getById(projectIdParam);

        const selectedProject = projectQuery.data.getProject;

        if (selectedProject.dataVisualization) {
          const dataVisualizationArray = JSON.parse(selectedProject.dataVisualization);
          if (dataVisualizationArray.length > index) {
            //get the url of the file
            Storage.get(dataVisualizationArray[index].s3Link)
              .then((result) => {
                dataVisualizationArray[index].url = result;
              })
              .then(() => {
                setVisualization(dataVisualizationArray[index]);
                setVisualizationTitle(dataVisualizationArray[index].title);
                setVisualizationDesc(dataVisualizationArray[index].desc);
              });
          }
        }
      } catch (error) {
        // console.error('Error fetching project:', error);
      }
    };

    fetchData();
  }, []);

  const handleUpdate = async () => {
    try {
      const projectQuery = await API.projects.getById(projectId);

      const selectedProject = projectQuery.data.getProject;

      if (selectedProject.dataVisualization) {
        const dataVisualizationArray = JSON.parse(selectedProject.dataVisualization);
        if (dataVisualizationArray.length > index) {
          dataVisualizationArray[index].title = visualizationTitle;
          dataVisualizationArray[index].desc = visualizationDesc;

          // Update the project in Django
          await API.projects.update({
            id: selectedProject.id,
            dataVisualization: JSON.stringify(dataVisualizationArray)
          });

          history.push("/visualization/my-files", {
            notificationShow: true,
            notification: {
              status: true,
              title: "Visualization Updated",
              message: `Your visualization "${visualizationTitle}" has been updated successfully.`,
            },
          });
        }
      }
    } catch (error) {
      history.push("/visualization/my-files", {
        notificationShow: true,
        notification: {
          status: false,
          title: "Visualization Updated Failed",
          message: `Your visualization "${visualizationTitle}" failed to update.`,
        },
      });
    }
  };

  const type = () => {
    switch (visualization.type) {
      case "image":
        return "Image";
      case "pdf":
        return "PDF";
      case "video":
        return "Video";
    }
  };

  const viewFileInNewWindow = (pdfUrl) => {
    window.open(pdfUrl, "_blank");
  };

  return (
    <div className="container py-8 px-8 mx-0 min-w-full bg-gray-50 shadow rounded-xl border dark:bg-gray-800 dark:border-gray-700">
      <h2 className="text-base font-semibold leading-7 text-gray-900 mb-6 pb-2 border-b border-gray-200 dark:text-white dark:border-gray-700">
        Edit Your {type()} Visualization
      </h2>
      <div className="mt-6">
        <p className="mb-2 dark:text-white">Title</p>
        <input
          type="text"
          maxLength={100}
          className="border border-gray-300 rounded-md shadow-sm focus:ring-1 focus:ring-blue-500 outline-none focus:border-blue-500 px-4 py-2 w-full"
          value={visualizationTitle}
          onChange={handleTitleChange}
        />
      </div>

      <div className="mt-6">
        <p className="mb-2 dark:text-white">Description</p>
        <textarea
          className="border border-gray-300 rounded-lg px-4 py-2 w-full resize-y mb-4"
          maxLength={800}
          rows={6}
          value={visualizationDesc}
          onChange={handleDescChange}
        />
      </div>

      {visualization.type === "image" && (
        <img
          onClick={() => viewFileInNewWindow(visualization.url)}
          src={visualization.url}
          alt={visualization.title}
          className="w-2/5 max-w-full max-h-full"
        />
      )}
      {visualization.type === "pdf" && (
        <div onClick={() => viewFileInNewWindow(visualization.url)} className="w-full h-64 overflow-auto">
          <Document
            file={visualization.url}
            onLoadSuccess={({ numPages }) => {
              setNumPages(numPages);
            }}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={index}
                pageNumber={index + 1}
                scale={1}
                renderAnnotationLayer={false}
                renderTextLayer={false}
              />
            ))}
          </Document>
        </div>
      )}
      {visualization.type === "video" && (
        <video onClick={() => viewFileInNewWindow(visualization.url)} className="w-3/6 p-0" controls>
          <source src={visualization.url} />
        </video>
      )}
      {visualization?.type?.includes("track") && (
        <div style={{ height: "300px", width: "100%", position: "relative" }}>
          {!visualizationsLoading[0] && (
            <div className="absolute z-10" style={{ height: "100%", width: "100%" }}>
              <div role="status" className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
                <svg
                  aria-hidden="true"
                  class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          )}
          <div
            className={`transition ease-in-out duration-150 ${
              !visualizationsLoading[0] ? "blur" : "blur-none"
            }`}
          >
            <MapContainer
              style={{
                height: "300px",
                width: "100%",
                zIndex: 0,
                position: "relative",
              }}
              center={[69.11868280984892, -105.04560470581056]}
              zoom={9}
              maxZoom={15}
              worldCopyJump={true}
              maxBoundsViscosity={1}
              minZoom={2}
            >
              <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}" />
              <GPXDisplay
                type={visualization.type}
                file={visualization.s3Link}
                index={0}
                setVisualizationsLoading={setVisualizationsLoading}
              />
            </MapContainer>
          </div>
        </div>
      )}

      <div className="mt-6">
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded disabled:bg-gray-300 disabled:cursor-not-allowed"
          onClick={handleUpdate}
        >
          Update
        </button>
      </div>
    </div>
  );
}
